module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [(_vm.childCategories.length > 0) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "title is-4"
  }, [_vm._v("Разделы")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "field"
  }, [_vm._l((_vm.childCategories), function(item) {
    return [_c('span', {
      class: _vm.cssClass('categories', item.id),
      on: {
        "click": function($event) {
          _vm.handleFilter('categories', item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n            ")])]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.models.length > 0) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "title is-4"
  }, [_vm._v("Модели")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "field"
  }, [_vm._l((_vm.models), function(item) {
    return [_c('span', {
      class: _vm.cssClass('models', item.id),
      on: {
        "click": function($event) {
          _vm.handleFilter('models', item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n            ")])]
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [(_vm.tags.length > 0) ? _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "title is-4"
  }, [_vm._v("Популярное")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "field"
  }, [_vm._l((_vm.tags), function(item) {
    return [_c('span', {
      class: _vm.cssClass('tags', item.id),
      on: {
        "click": function($event) {
          _vm.handleFilter('tags', item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name) + "\n            ")])]
  })], 2)])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1473aac3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/category-product-list/Filter.vue
// module id = 609
// module chunks = 2